import startSearchWithRefiners from './searchRefiners/startSearchWithRefiners';
import { clearRefiners, onClearRefinersButtonClicked } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';

export default orchestrator(onClearRefinersButtonClicked, () => {
    // Dispatch action to clear (i.e. reset) refiners.
    clearRefiners();

    // Start search.
    startSearchWithRefiners();
});
